// components/Footer/FooterSelector.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import Footer from './Footer';
import PublicFooter from './PublicFooter';

const FooterSelector = () => {
  const location = useLocation();
  const { isAuthenticated } = useUser();
  
  // Define public routes (always show public footer regardless of auth)
  const publicRoutes = [
    '/',
    '/login',
    '/signup', // if you have it
    '/services',
    '/departments',
    '/doctors',
    '/announcements',
    '/about',
    '/contact' // if you add it
  ];
  
  // QR code/invoice routes (public access with specific URLs)
  const qrCodeRoutes = [
    '/service-payment-details',
    '/medication-invoice',
    '/lab-invoice',
    '/imaging-invoice',
    '/procedure-invoice',
    '/lab-results',
    '/imaging-results'
  ];
  
  // Check if current path matches QR code routes pattern
  const isQrCodeRoute = qrCodeRoutes.some(route => 
    location.pathname.startsWith(route)
  );
  
  // Medical certificate route pattern
  const isMedicalCertRoute = location.pathname.startsWith('/medical-certeficate-data/');
  
  const currentPath = location.pathname;
  const isPublicRoute = publicRoutes.includes(currentPath);
  
  // Determine which footer to show
  
  // 1. Always show public footer for public routes
  if (isPublicRoute) {
    return <PublicFooter />;
  }
  
  // 2. Show public footer for QR code and medical certificate routes
  if (isQrCodeRoute || isMedicalCertRoute) {
    return <PublicFooter />;
  }
  
  // 3. Show authenticated footer for authenticated users on non-public routes
  if (isAuthenticated) {
    return <Footer />;
  }
  
  // 4. For non-public routes when not authenticated (e.g., trying to access dashboard directly)
  // Show no footer or redirect happens via ProtectedRoute
  return null;
};

export default FooterSelector;